function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import moment from 'moment';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { MetadataCodeLoadedSelector, MetadataCodeTypeDictionarySelector, MetadataCodeTypeSelector, MetadataOptionsForCodeValuesSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { CurrentBusinessUnitCurrencyCodeSelector, IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { retrieveProductsMetadata } from 'invision-core/src/components/metadata/products/products.actions';
import __ from 'ramda/src/__';
import clone from 'ramda/src/clone';
import isEmpty from 'ramda/src/isEmpty';
import pathOr from 'ramda/src/pathOr';
import pluck from 'ramda/src/pluck';
import propEq from 'ramda/src/propEq';
import reject from 'ramda/src/reject';
import without from 'ramda/src/without';
import CustomerCareKeys from '../../../../../../../locales/keys';
import { clearCartSummaryForWaiveCharge, retrieveOrderContext, setPreviouslySelectedPaymentInstrumentIds, setProductOrderCouponCodes, setProductOrderDiscretionaryDiscounts, updateSearchCatalogParams } from '../../../../../../../reducers/actions/products.order.actions';
import { CurrencySelector, CurrentSubscriptionHasLateFeeSelector, CurrentSubscriptionSelector, ShippingAddressSelector } from './../../../../../../../reducers/selectors/customer.subscriptions.selectors';
import { IsModifyingModeSelector, IsReplacingModeSelector, IsRestoringModeSelector, SubscriptionsOnlySelector } from '../../create.products.order.wizard.selectors';
import { BillingEffectiveDateOptionsSelector, BillingEffectiveDateSettingsSelector, CartContainsProductWithBillerRuleCycleLevelOtherThanItemSelector, DiscretionaryDiscountsIdSelector, DiscretionaryDiscountsReasonSelector, DiscretionaryDiscountsSelector, DoPaymentInstrumentsCoverOrderTotalSelector, HasPrepaidPricingPlanSelector, InvalidCouponRedemptionViewModelSelector, IsDbssShoppingCart, IsSelectedProductAdHoc, IsSelectedProductDbss, IsServiceFeatureShoppingCart, IsValidatingCoupon, ModifiedSubscriptionItemSelector, OrderQuoteIsValidSelector, OrderRequiresShippingSelector, PreviouslySelectedPaymentInstrumentIdsSelector, SearchCatalogParamsSelector, SelectablePaymentInstrumentForServiceFeaturesSelector, SelectablePaymentInstrumentSelector, ShippingMethodsViewModel, ShoppingCartItemDetailsLocationCodesSelector, ShoppingCartSelector, UnfilteredCouponCodesSelector, UngiftableShoppingCartItemSelector } from '../../../../../../../reducers/selectors/products.order.selectors';
import { CurrentCustomerCurrencyCodeSelector, CurrentCustomerIdSelector, RouteParams } from '../../../../../../../reducers/selectors/customer.selectors';
import { PaymentInstrumentsCanBeUsedForOrderingContainingBalanceSelector, PaymentInstrumentsWithoutBillToInvoiceSelector, PaymentIsFetchingDataSelector, RecordPaymentInformationSelector, SelectedPaymentMethodSelector } from '../../../../../../../reducers/selectors/customer.ewallet.selectors';
import { CurrentHouseholdSelector, CurrentMemberHasCreatePaymentInstrumentPermissionsSelector } from '../../../../../../../reducers/selectors/customer.household.selectors';
import { setDiscountForm } from '../../../../../../../reducers/actions/discount.actions';
import { ChangeImmediateSelector, IsProductWizardRestoreOrderWaivingFeeSelector, IsProductWizardRestoreOrderWaivingLateFeeSelector, IsShippingAddressSameAsBillingSelector, IsShippingMethodsAvailableSelector, OttExecutionOptionsSelector, PaymentInstrumentsSelector, PaymentInstrumentIdsSelector, PaymentInstrumentIdsValidInQuoteSelector, ProductOrderShippingAddressIdSelector, ProductWizardGiftOrderInfoSelector, ProductWizardIsGiftOrderSelector, ProductWizardRestoreOrderWaiveFeeReasonSelector, ProductWizardRestoreOrderWaiveLateFeeReasonSelector, ProductWizardTemporaryShipToNameSelector } from '../../../../../../../reducers/selectors/products.wizard.selectors';
import { retrieveCustomerAddresses } from '../../../../../../../reducers/actions/customer.addresses.actions';
import { setChangeImmediately, setGiftOrderInfo, setIsGiftOrder, setIsShippingAddressSameAsBilling, setOrderDetails, setOttExecutionOptions, setPaymentInstruments, setPaymentInstrumentIds, setProductOrderShippingAddressId, setRestoreOrderWaiveFee, setRestoreOrderWaiveFeeReason, setRestoreOrderWaiveLateFee, setRestoreOrderWaiveLateFeeReason, setSelectedShippingMethodId, setTemporaryShipToName } from '../../../../../../../reducers/actions/products.wizard.actions';
import { addUnsavedPaymentMethod, retrieveAvailablePaymentInstrumentTypes, retrieveWallet, setRecordPaymentInstrument } from '../../../../../../../reducers/actions/customer.ewallet.actions';
import { retrieveCustomerHouseholds } from '../../../../../../../reducers/actions/customer.household.actions';
import { getDefaultPaymentMethodFromPaymentInstruments } from '../../../../../../../reducers/helpers/ewallet.reducer.helper';
import { ORDER_TYPE_CODE, REGEXES } from '../../../../../../../customercare.constants';
import { CurrentActiveAddressesSelector, CurrentAddressesSelector, DefaultShippingAddressSelector } from '../../../../../../../reducers/selectors/customer.addresses.selectors';
import { STRUCTURE_TYPES } from '../../../../../../../reducers/constants/structure.type.constants';
import { GENERAL_STATUSES } from '../../../../../../shared/constants/general.status.constants';
import { SUPPORTED_OTT_PAYMENT_INSTRUMENT_TYPES } from '../../../../../ewallet/ewallet.constants';
import { CandidateBillCyclesSelector } from '../../../../../../../reducers/selectors/customer.billcycle.selectors';
import { retrieveCandidateBillCycles } from '../../../../../../../reducers/actions/customer.billcycle.actions';
import { GetMaxDateForFutureDatedOrder, IsFutureDatedOrderAllowedInBunt } from '../../../../../../../reducers/selectors/selected.offering.order.selectors';
import { subscriberOrderTypeEnum } from 'invision-core/src/utilities/subscriber.order.type.enum';
var CONVERGENT_BILLER_INVOICE = Number(SUPPORTED_OTT_PAYMENT_INSTRUMENT_TYPES.CONVERGENT_BILLER_INVOICE);
var CheckoutController = /*#__PURE__*/function () {
  function CheckoutController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, CheckoutController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      addressSwitcherAddress: null,
      applyDiscount: this.applyDiscount.bind(this),
      canCreatePaymentInstruments: this.canCreatePaymentInstruments.bind(this),
      closeDiscountDialog: this.closeDiscountDialog.bind(this),
      currentDateTime: new Date(),
      doErrorsExistOnFdoForm: this.doErrorsExistOnFdoForm.bind(this),
      emailPattern: REGEXES.EMAIL,
      executionOptionsMinDate: moment(this.getTomorrow()).startOf('day').utc().toISOString(),
      formFieldLocaleKeyMapping: {
        addressShipToName: CustomerCareKeys.ADDRESSES.SHIP_TO_NAME,
        waiveFeeReason: CustomerCareKeys.SUBSCRIPTIONS.WAIVE_CHARGE_REASON,
        SpecifiedDate: 'test'
      },
      giftOrderInfo: {
        currentDateTime: new Date(),
        giftMessage: null,
        notificationDate: new Date(),
        recipientName: null
      },
      initializedHouseholdData: false,
      initializedWallet: false,
      isLoadingData: this.isLoadingData.bind(this),
      isShippingAddressSameAsBilling: true,
      localeKeys: CustomerCareKeys,
      MAXIMUM_COMMENT_LENGTH: 500,
      onAddAnotherPaymentClicked: this.onAddAnotherPaymentClicked.bind(this),
      onAddPaymentInstrumentCallback: this.onAddPaymentInstrumentCallback.bind(this),
      onAddressSwitcherChangeCallback: this.onAddressSwitcherChangeCallback.bind(this),
      onAddressSwitcherCreateOrEditCallback: this.onAddressSwitcherCreateOrEditCallback.bind(this),
      onChangeImmediatelyCallback: this.onChangeImmediatelyCallback.bind(this),
      onChangePaymentInstrumentCallback: this.onChangePaymentInstrumentCallback.bind(this),
      onChangeTemporaryShipToName: this.onChangeTemporaryShipToName.bind(this),
      onEditDiscountClick: this.onEditDiscountClick.bind(this),
      onEditPaymentInstrumentCallback: this.onEditPaymentInstrumentCallback.bind(this),
      onExecutionOptionChange: this.onExecutionOptionChange.bind(this),
      onFdoFormValidityChange: this.onFdoFormValidityChange.bind(this),
      onListUpdated: this.onListUpdated.bind(this),
      onPropertyChanged: this.onPropertyChanged.bind(this),
      onRemoveDiscountClick: this.onRemoveDiscountClick.bind(this),
      onShippingAddressSameAsBillingChanged: this.onShippingAddressSameAsBillingChanged.bind(this),
      onWaiveFeeReasonSelected: this.onWaiveFeeReasonSelected.bind(this),
      onWaiveFeeSelected: this.onWaiveFeeSelected.bind(this),
      onWaiveLateFeeReasonSelected: this.onWaiveLateFeeReasonSelected.bind(this),
      onWaiveLateFeeSelected: this.onWaiveLateFeeSelected.bind(this),
      openDiscountDialog: this.openDiscountDialog.bind(this),
      ORDER_COMMENT_MAX_LENGTH: 500,
      orderDetails: {},
      paymentInstrument: {},
      readOnlyInstruments: [],
      reasonCodes: [],
      removePaymentInstrument: this.removePaymentInstrument.bind(this),
      selectablePaymentInstruments: [],
      setOrderDetails: this.setOrderDetails.bind(this),
      setProductOrderDiscretionaryDiscounts: this.setProductOrderDiscretionaryDiscounts.bind(this),
      shippingMethodSelected: this.shippingMethodSelected.bind(this),
      shouldHideSameAsBillingCheckbox: this.shouldHideSameAsBillingCheckbox.bind(this),
      shouldShowAdditionalPaymentMethods: this.shouldShowAdditionalPaymentMethods.bind(this),
      showDiscountForm: false,
      uiNotificationService: uiNotificationService,
      validations: {
        DEFAULT_MAX_LENGTH: 100,
        GIFT_MESSAGE_MAX_LENGTH: 500,
        SHIP_TO_NAME_MAX_LENGTH: 200
      }
    });
  }
  return _createClass(CheckoutController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          applyDiscountDialogApi: null,
          billingEffectiveDateOptions: BillingEffectiveDateOptionsSelector(store),
          billingEffectiveDateSettings: BillingEffectiveDateSettingsSelector(store),
          candidateBillCycles: CandidateBillCyclesSelector(store),
          cartContainsProductWithBillerRuleCycleLevelOtherThanItem: CartContainsProductWithBillerRuleCycleLevelOtherThanItemSelector(store),
          changeImmediately: ChangeImmediateSelector(store),
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          couponCodes: UnfilteredCouponCodesSelector(store),
          currency: CurrencySelector(store),
          currentActiveAddresses: CurrentActiveAddressesSelector(store),
          currentAddresses: CurrentAddressesSelector(store),
          currentBusinessUnitCurrencyCode: CurrentBusinessUnitCurrencyCodeSelector(store),
          currentCustomerCurrencyCode: CurrentCustomerCurrencyCodeSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentHousehold: CurrentHouseholdSelector(store),
          currentMemberCanCreatePaymentInstrument: CurrentMemberHasCreatePaymentInstrumentPermissionsSelector(store),
          currentSubscription: CurrentSubscriptionSelector(store),
          currentSubscriptionShippingAddress: ShippingAddressSelector(store),
          defaultShippingAddress: DefaultShippingAddressSelector(store),
          discretionaryDiscounts: DiscretionaryDiscountsSelector(store),
          discretionaryDiscountsId: DiscretionaryDiscountsIdSelector(store),
          discretionaryDiscountsReason: DiscretionaryDiscountsReasonSelector(store),
          doPaymentInstrumentsCoverOrderTotal: DoPaymentInstrumentsCoverOrderTotalSelector(store),
          executionOptions: OttExecutionOptionsSelector(store),
          fdoAllowedInBunt: IsFutureDatedOrderAllowedInBunt(store),
          fdoConfiguration: MetadataCodeTypeSelector(CODES.FutureDatedOrderConfiguration, store),
          fdoConfigurationLoaded: MetadataCodeLoadedSelector(CODES.FutureDatedOrderConfiguration, store),
          fdoMaxDate: GetMaxDateForFutureDatedOrder(store),
          giftOrderInfo: ProductWizardGiftOrderInfoSelector(store),
          hasPrepaid: HasPrepaidPricingPlanSelector(store),
          invalidCouponRedemptions: InvalidCouponRedemptionViewModelSelector(store),
          isDbss: IsDbss(store),
          isDbssShoppingCart: IsDbssShoppingCart(store),
          isFetchingWalletData: PaymentIsFetchingDataSelector(store),
          isGiftOrder: ProductWizardIsGiftOrderSelector(store),
          isModifyingMode: IsModifyingModeSelector(store),
          isReplacingMode: IsReplacingModeSelector(store),
          isRestoringMode: IsRestoringModeSelector(store),
          isSelectedProductAdHoc: IsSelectedProductAdHoc(store),
          isSelectedProductDbss: IsSelectedProductDbss(store),
          isServiceFeatureShoppingCart: IsServiceFeatureShoppingCart(store),
          isShippingAddressSameAsBilling: IsShippingAddressSameAsBillingSelector(store),
          isShippingMethodsAvailable: IsShippingMethodsAvailableSelector(store),
          isValidatingCoupon: IsValidatingCoupon(store),
          locationCodes: ShoppingCartItemDetailsLocationCodesSelector(store),
          modifiedSubscriptionItem: ModifiedSubscriptionItemSelector(store),
          paymentInstrumentFunds: {
            isOrderTotalCovered: DoPaymentInstrumentsCoverOrderTotalSelector(store),
            paymentInstrumentsNotRecorded: PaymentInstrumentsSelector(store),
            recordPaymentInfo: RecordPaymentInformationSelector(store),
            selectedPaymentIds: PaymentInstrumentIdsSelector(store)
          },
          paymentInstrumentsNotRecorded: PaymentInstrumentsSelector(store),
          paymentInstrumentsWithBalance: _this.determinePaymentInstrumentsWithBalanceSelector(store),
          previouslySelectedPaymentInstrumentIds: PreviouslySelectedPaymentInstrumentIdsSelector(store),
          quoteIsValid: OrderQuoteIsValidSelector(store),
          reasonCodes: MetadataCodeTypeDictionarySelector(CODES.ReasonCodes, store),
          reasonCodesLoaded: MetadataCodeLoadedSelector(CODES.ReasonCodes, store),
          recordPaymentInfo: RecordPaymentInformationSelector(store),
          routeParams: RouteParams(store),
          searchCatalogParams: SearchCatalogParamsSelector(store),
          selectablePaymentInstruments: _this.determineSelectablePaymentInstrumentsSelector(store),
          selectedPaymentMethod: SelectedPaymentMethodSelector(store),
          selectedPaymentInstrumentIds: PaymentInstrumentIdsValidInQuoteSelector(store),
          selectedShippingAddressId: ProductOrderShippingAddressIdSelector(store),
          shippingMethods: ShippingMethodsViewModel(store),
          shippingRequired: OrderRequiresShippingSelector(store),
          shoppingCart: ShoppingCartSelector(store),
          subscriptionHasLateFee: CurrentSubscriptionHasLateFeeSelector(store),
          subscriptionOnly: SubscriptionsOnlySelector(store),
          temporaryShipToName: ProductWizardTemporaryShipToNameSelector(store),
          timeZonesLoaded: MetadataCodeLoadedSelector(CODES.TimeZone, store),
          ungiftableProducts: UngiftableShoppingCartItemSelector(store),
          waiveFee: IsProductWizardRestoreOrderWaivingFeeSelector(store),
          waiveFeeReason: ProductWizardRestoreOrderWaiveFeeReasonSelector(store),
          waiveFeeReasonOptions: MetadataOptionsForCodeValuesSelector(CODES.WaiveFeeReason, store),
          waiveLateFee: IsProductWizardRestoreOrderWaivingLateFeeSelector(store),
          waiveLateFeeReason: ProductWizardRestoreOrderWaiveLateFeeReasonSelector(store)
        };
      };
      var controllerActions = {
        addUnsavedPaymentMethod: addUnsavedPaymentMethod,
        clearCartSummaryForWaiveCharge: clearCartSummaryForWaiveCharge,
        fetchCodeTypes: fetchCodeTypes,
        retrieveAvailablePaymentInstrumentTypes: retrieveAvailablePaymentInstrumentTypes,
        retrieveCandidateBillCycles: retrieveCandidateBillCycles,
        retrieveCustomerAddresses: retrieveCustomerAddresses,
        retrieveCustomerHouseholds: retrieveCustomerHouseholds,
        retrieveOrderContext: retrieveOrderContext,
        retrieveProductsMetadata: retrieveProductsMetadata,
        retrieveWallet: retrieveWallet,
        setChangeImmediately: setChangeImmediately,
        setDiscountForm: setDiscountForm,
        setGiftOrderInfo: setGiftOrderInfo,
        setIsGiftOrder: setIsGiftOrder,
        setIsShippingAddressSameAsBilling: setIsShippingAddressSameAsBilling,
        setOrderDetails: setOrderDetails,
        setOttExecutionOptions: setOttExecutionOptions,
        setPaymentInstruments: setPaymentInstruments,
        setPaymentInstrumentIds: setPaymentInstrumentIds,
        setPreviouslySelectedPaymentInstrumentIds: setPreviouslySelectedPaymentInstrumentIds,
        setProductOrderCouponCodes: setProductOrderCouponCodes,
        setProductOrderDiscretionaryDiscounts: setProductOrderDiscretionaryDiscounts,
        setProductOrderShippingAddressId: setProductOrderShippingAddressId,
        setRecordPaymentInstrument: setRecordPaymentInstrument,
        setRestoreOrderWaiveFee: setRestoreOrderWaiveFee,
        setRestoreOrderWaiveFeeReason: setRestoreOrderWaiveFeeReason,
        setRestoreOrderWaiveLateFee: setRestoreOrderWaiveLateFee,
        setRestoreOrderWaiveLateFeeReason: setRestoreOrderWaiveLateFeeReason,
        setSelectedShippingMethodId: setSelectedShippingMethodId,
        setTemporaryShipToName: setTemporaryShipToName,
        updateSearchCatalogParams: updateSearchCatalogParams
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
        _this.setSelectedCurrentPaymentInstrument();
      });
      var productIds = pluck('ProductId', pathOr([], ['Items'], this.state.shoppingCart));
      this.actions.retrieveProductsMetadata(productIds).then(function () {
        if (_this.state.isDbss && _this.state.cartContainsProductWithBillerRuleCycleLevelOtherThanItem) {
          _this.actions.retrieveCandidateBillCycles(_this.state.currentCustomerId, subscriberOrderTypeEnum.postpaid.value).catch(function (error) {
            _this.uiNotificationService.transientError(error.translatedMessage);
          });
        }
      });
      this.applyDiscountDialogConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.applyDiscountDialogApi = api;
        }
      };
      if (!this.state.fdoConfigurationLoaded) {
        this.actions.fetchCodeTypes(CODES.FutureDatedOrderConfiguration);
      }
      if (this.state.isRestoringMode && !this.state.codeTypeLoaded(CODES.WaiveFeeReason)) {
        this.actions.fetchCodeTypes(CODES.WaiveFeeReason);
      }
      if (!this.state.timeZonesLoaded) {
        this.actions.fetchCodeTypes(CODES.TimeZone);
      }
      if (!this.state.reasonCodesLoaded) {
        this.actions.fetchCodeTypes(CODES.ReasonCodes).then(function () {
          _this.reasonCodes = _this.getFilteredReasonCodes();
        });
      }
      this.additionalPropertyFileds = clone(this.additionalPropertiesCollection);

      // TODO Customer Order skip all these calls on checkout for DBSS we don't need for submitting an order
      // Coupons, Discretionary, & Discounts & Gifting do not apply for DBSS?
      if (!this.state.isDbssShoppingCart) {
        this.loadCustomerAddresses();
        this.loadHouseholdData();
        this.initGiftOrder();
        this.retrieveWalletAndSetInitialPaymentInstrument();
      } else {
        // TODO (CustomerOrder): When Checkout is refactored, make this a helpe that is called when nedessary so
        // it will have more explicit control.
        this.actions.retrieveOrderContext(this.state.currentCustomerId).catch(function (error) {
          _this.uiNotificationService.transientError(error.translatedMessage);
        });
        this.onChange()(); // Used to initiate calculate order quote on the parent component.
      }
      if (!this.shouldShowApplyChanges()) {
        this.actions.setChangeImmediately(true);
      } else if (this.state.isReplacingMode && this.shouldShowApplyChanges()) {
        this.actions.setChangeImmediately(true);
      }
      this.setDefaultBillCycle();
      this.actions.retrieveAvailablePaymentInstrumentTypes({
        Currency: this.state.currentCustomerCurrencyCode || this.state.currentBusinessUnitCurrencyCode,
        ShoppingCart: {
          Items: this.state.shoppingCart
        }
      }).catch(function (error) {
        _this.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "$doCheck",
    value: function $doCheck() {
      if (this.formController.selectedShippingAddress) {
        if (!this.state.selectedShippingAddressId) {
          this.formController.selectedShippingAddress.$setValidity('isShippingAddressSelected', false);
        } else {
          this.formController.selectedShippingAddress.$setValidity('isShippingAddressSelected', true);
        }
      }
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      var _this2 = this;
      this.$timeout(function () {
        if (!_this2.state.isDbssShoppingCart) {
          // *true* indicates validation succeeded
          if (_this2.formController.paymentInstrumentsFunds) {
            _this2.formController.paymentInstrumentsFunds.$validators.doPaymentInstrumentsCoverOrderTotal = function (modelValue) {
              // Marking validation as *true* is Expired/Inactive Payment Instrument is selected. Else it shows multiple errors when you switch from External Gift Card with insufficient balance to Expired/Inactive Credit Card.
              return _this2._containsExpiredPaymentInstrument(modelValue.selectedPaymentIds) || _this2.isPaymentInstrumentRemoved() || _this2._containsInvoicePaymentInstrument(modelValue.selectedPaymentIds) || _this2.state.isServiceFeatureShoppingCart ? true : modelValue.isOrderTotalCovered;
            };
            _this2.formController.paymentInstrumentsFunds.$validators.isPaymentInstrumentSelected = function (modelValue) {
              return _this2.state.isServiceFeatureShoppingCart ? !_this2.state.hasPrepaid || !!modelValue.selectedPaymentIds.length || !!modelValue.paymentInstrumentsNotRecorded.length && !modelValue.recordPaymentInfo : !!modelValue.selectedPaymentIds.length || !!modelValue.paymentInstrumentsNotRecorded.length && !modelValue.recordPaymentInfo || !pathOr(true, ['state', 'shoppingCart', 'PaymentInstrumentRequired'], _this2);
            };
            _this2.formController.paymentInstrumentsFunds.$validators.isPaymentInstrumentExpirationValid = function (modelValue) {
              return _this2._containsInvoicePaymentInstrument(modelValue.selectedPaymentIds) ? true : !_this2._containsExpiredPaymentInstrument(modelValue.selectedPaymentIds);
            };
            _this2.formController.paymentInstrumentsFunds.$validators.isPaymentInstrumentInactive = function () {
              return !_this2.isPaymentInstrumentRemoved();
            };
          }
        }
      });
    }
  }, {
    key: "determinePaymentInstrumentsWithBalanceSelector",
    value: function determinePaymentInstrumentsWithBalanceSelector(store) {
      return this.state && this.state.isServiceFeatureShoppingCart ? PaymentInstrumentsWithoutBillToInvoiceSelector(store) : PaymentInstrumentsCanBeUsedForOrderingContainingBalanceSelector(store);
    }
  }, {
    key: "determineSelectablePaymentInstrumentsSelector",
    value: function determineSelectablePaymentInstrumentsSelector(store) {
      return this.state && this.state.isServiceFeatureShoppingCart ? SelectablePaymentInstrumentForServiceFeaturesSelector(store) : SelectablePaymentInstrumentSelector(store);
    }
  }, {
    key: "loadCustomerAddresses",
    value: function loadCustomerAddresses() {
      var _this3 = this;
      if (!this.state.currentAddresses || !this.state.currentAddresses.length) {
        this.actions.retrieveCustomerAddresses(this.state.currentCustomerId).then(function () {
          var previouslySelectedAddressSwitcherAddress = _this3.state.currentActiveAddresses.find(propEq(_this3.state.selectedShippingAddressId, 'Id'));
          _this3.addressSwitcherAddress = previouslySelectedAddressSwitcherAddress || _this3.state.defaultShippingAddress;
          if (!_this3.addressSwitcherAddress) {
            _this3.actions.setIsShippingAddressSameAsBilling(true);
          }
        });
      } else {
        var previouslySelectedAddressSwitcherAddress = this.state.currentActiveAddresses.find(propEq(this.state.selectedShippingAddressId, 'Id'));
        this.addressSwitcherAddress = previouslySelectedAddressSwitcherAddress || this.state.defaultShippingAddress;
        if (!this.addressSwitcherAddress) {
          this.actions.setIsShippingAddressSameAsBilling(true);
        }
      }
    }
  }, {
    key: "hasPaymentInstruments",
    value: function hasPaymentInstruments() {
      return !!((this.state.selectablePaymentInstruments || []).length || (this.state.paymentInstrumentsWithBalance || []).length);
    }
  }, {
    key: "initGiftOrder",
    value: function initGiftOrder() {
      this.isGiftOrder = this.state.isGiftOrder;
      if (!isEmpty(this.state.giftOrderInfo)) {
        this.giftOrderInfo = clone(this.state.giftOrderInfo);
      }
    }
  }, {
    key: "handleApplyCouponCode",
    value: function handleApplyCouponCode(couponCode) {
      if (!this.state.couponCodes.find(propEq(couponCode, 'name'))) {
        // only apply the coupon if it's unique (not already applied)
        this.actions.setProductOrderCouponCodes([{
          name: couponCode,
          description: null
        }].concat(this.state.couponCodes));
      }
      this.onChange()();
    }
  }, {
    key: "handleRemoveCouponCode",
    value: function handleRemoveCouponCode(couponCode) {
      this.actions.setProductOrderCouponCodes(reject(propEq(couponCode.name, 'name'), this.state.couponCodes));
      if (couponCode.name === this.state.searchCatalogParams.ProductFilter.CouponCode) {
        var searchParameters = clone(this.state.searchCatalogParams);
        searchParameters.ProductFilter.CouponCode = undefined;
        this.actions.updateSearchCatalogParams(searchParameters);
      }
      this.onChange()();
    }
  }, {
    key: "onChangeTemporaryShipToName",
    value: function onChangeTemporaryShipToName() {
      this.actions.setTemporaryShipToName(this.temporaryShipToName);
    }
  }, {
    key: "_getPaymentInstrument",
    value: function _getPaymentInstrument(id) {
      return this.state.selectablePaymentInstruments.find(propEq(id, 'Id'));
    }
  }, {
    key: "_containsExpiredPaymentInstrument",
    value: function _containsExpiredPaymentInstrument(paymentInstrumentIds) {
      var _this4 = this;
      var expiredCreditCards = paymentInstrumentIds.filter(function (pid) {
        var pi = _this4._getPaymentInstrument(pid);
        return pi && pi.CreditCard ? _this4._isCreditCardExpired(pi.CreditCard) : false;
      });
      return expiredCreditCards.length;
    }
  }, {
    key: "_containsInvoicePaymentInstrument",
    value: function _containsInvoicePaymentInstrument(paymentInstrumentIds) {
      var _this5 = this;
      return paymentInstrumentIds.some(function (id) {
        var paymentInstrument = _this5._getPaymentInstrument(id);
        return paymentInstrument && paymentInstrument.Type === CONVERGENT_BILLER_INVOICE;
      });
    }
  }, {
    key: "_isCreditCardExpired",
    value: function _isCreditCardExpired(creditCardDetails) {
      var formattedCreditCardExpiration = "".concat(creditCardDetails.ExpirationMonth, "/").concat(creditCardDetails.ExpirationYear);
      return moment(formattedCreditCardExpiration, 'MM/YYYY').isBefore(moment(), 'month');
    }
  }, {
    key: "shouldShowAdditionalPaymentMethods",
    value: function shouldShowAdditionalPaymentMethods() {
      return this.state.selectablePaymentInstruments.length && !this.state.doPaymentInstrumentsCoverOrderTotal && this.state.paymentInstrumentsWithBalance.length >= this.state.selectedPaymentInstrumentIds.length && this.paymentInstrument && !(this.paymentInstrument.CreditCard && this._isCreditCardExpired(this.paymentInstrument.CreditCard) || this.isPaymentInstrumentRemoved());
    }
  }, {
    key: "onAddAnotherPaymentClicked",
    value: function onAddAnotherPaymentClicked() {
      this.actions.setPreviouslySelectedPaymentInstrumentIds(this.previouslySelectedPaymentInstrumentIds.concat(this.paymentInstrument.Id));
      this.paymentInstrument = getDefaultPaymentMethodFromPaymentInstruments(this.state.selectablePaymentInstruments);
      this.addPaymentInstrument(this.paymentInstrument);
    }
  }, {
    key: "removePaymentInstrument",
    value: function removePaymentInstrument(paymentInstrumentId) {
      //Remove the trailing read only instruments
      var updatedPreviouslySelectedPaymentInstrumentIds = this.previouslySelectedPaymentInstrumentIds.filter(function (previouslySelectedPaymentInstrumentId) {
        return previouslySelectedPaymentInstrumentId !== paymentInstrumentId;
      });
      if (!this.paymentInstrument) {
        // previously all PIs in the list were used
        if (updatedPreviouslySelectedPaymentInstrumentIds.length === 0 && this.previouslySelectedPaymentInstrumentIds.length === 1) {
          updatedPreviouslySelectedPaymentInstrumentIds.push(paymentInstrumentId);
        }

        // need to set this.paymentInstrument to the last in the list
        var lastPaymentInstrumentId = updatedPreviouslySelectedPaymentInstrumentIds.pop();
        this.paymentInstrument = this.state.paymentInstrumentsWithBalance.find(function (pi) {
          return pi.Id === lastPaymentInstrumentId;
        });
      }
      this.actions.setPreviouslySelectedPaymentInstrumentIds(updatedPreviouslySelectedPaymentInstrumentIds);
      this.actions.setPaymentInstrumentIds(updatedPreviouslySelectedPaymentInstrumentIds.concat([this.paymentInstrument.Id]));
      this.onChange()();
    }
  }, {
    key: "loadHouseholdData",
    value: function loadHouseholdData() {
      var _this6 = this;
      if (!this.state.currentHousehold) {
        this.actions.retrieveCustomerHouseholds(this.state.currentCustomerId, false).finally(function () {
          _this6.initializedHouseholdData = true;
        });
      } else {
        this.initializedHouseholdData = true;
      }
    }
  }, {
    key: "retrieveWalletAndSetInitialPaymentInstrument",
    value: function retrieveWalletAndSetInitialPaymentInstrument() {
      var _this7 = this;
      this.actions.retrieveWallet({
        customerId: this.state.currentCustomerId
      }, true).then(function () {
        if (_this7.state.paymentInstrumentsWithBalance.length) {
          var paymentInstruments = _this7.selectedPaymentIdsToInstruments(_this7.state.selectedPaymentInstrumentIds, _this7.state.paymentInstrumentsWithBalance);
          _this7.selectablePaymentInstruments = _this7.state.paymentInstrumentsWithBalance;
          if (_this7.state.isModifyingMode || _this7.state.isRestoringMode || _this7.state.isReplacingMode) {
            _this7.paymentInstrument = _this7.state.currentSubscription.PaymentInstrument;
          } else if (paymentInstruments && paymentInstruments.length) {
            while (paymentInstruments.length && !_this7.paymentInstrument.Id) {
              _this7.paymentInstrument = paymentInstruments.asMutable().pop();
              if (_this7.state.previouslySelectedPaymentInstrumentIds.includes(_this7.paymentInstrument.Id)) {
                _this7.paymentInstrument = undefined;
              }
            }
            _this7.readOnlyInstruments = paymentInstruments;
            _this7.selectablePaymentInstruments = without(_this7.readOnlyInstruments, _this7.selectablePaymentInstruments);
          } else {
            _this7.paymentInstrument = getDefaultPaymentMethodFromPaymentInstruments(_this7.state.paymentInstrumentsWithBalance);
          }
          _this7.isShippingAddressSameAsBilling = _this7.state.isShippingAddressSameAsBilling;
          var billingAddress = pathOr(null, ['BillingAddress', 'Id'], _this7.paymentInstrument);
          if (_this7.isShippingAddressSameAsBilling && billingAddress) {
            _this7.actions.setProductOrderShippingAddressId(billingAddress);
          } else {
            _this7.isShippingAddressSameAsBilling = false;
            _this7.actions.setIsShippingAddressSameAsBilling(_this7.isShippingAddressSameAsBilling);
            _this7.addressSwitcherAddress = _this7.state.currentSubscriptionShippingAddress || _this7.state.defaultShippingAddress || _this7.state.currentActiveAddresses[0];
            _this7.actions.setProductOrderShippingAddressId(_this7.getAddressSwitcherAddressId());
          }
          _this7.onChangePaymentInstrumentCallback(_this7.paymentInstrument);
        } else {
          _this7.onChangePaymentInstrumentCallback();
        }
      }).catch(function (error) {
        _this7.uiNotificationService.transientError(error.translatedMessage);
      }).finally(function () {
        _this7.initializedWallet = true;
      });
    }
  }, {
    key: "setSelectedCurrentPaymentInstrument",
    value: function setSelectedCurrentPaymentInstrument() {
      this.previouslySelectedPaymentInstrumentIds = this.state.previouslySelectedPaymentInstrumentIds;
      if (this.paymentInstrument && !this.state.selectedPaymentInstrumentIds.includes(this.paymentInstrument.Id) && this.previouslySelectedPaymentInstrumentIds.length) {
        this.actions.setPaymentInstrumentIds(this.previouslySelectedPaymentInstrumentIds.concat([this.paymentInstrument.Id]));
      }
    }
  }, {
    key: "onChangeImmediatelyCallback",
    value: function onChangeImmediatelyCallback(changeImmediately) {
      this.actions.setChangeImmediately(changeImmediately);
      this.onChange()();
    }
  }, {
    key: "onAddPaymentInstrumentCallback",
    value: function onAddPaymentInstrumentCallback(paymentInstrument) {
      this.selectablePaymentInstruments = without(this.readOnlyInstruments, [paymentInstrument].concat(this.state.paymentInstrumentsWithBalance));
      if (!this.addressSwitcherAddress) {
        this.addressSwitcherAddress = paymentInstrument.BillingAddress;
      }
      this.onChangePaymentInstrumentCallback(paymentInstrument);
    }
  }, {
    key: "onChangePaymentInstrumentCallback",
    value: function onChangePaymentInstrumentCallback(paymentInstrument) {
      this.temporaryShipToName = null;
      this.onEditPaymentInstrumentCallback(paymentInstrument);
    }
  }, {
    key: "onEditPaymentInstrumentCallback",
    value: function onEditPaymentInstrumentCallback(paymentInstrument) {
      //Set the current active payment instrument
      this.paymentInstrument = paymentInstrument;
      if (paymentInstrument && paymentInstrument.Id > 0) {
        this.actions.setRecordPaymentInstrument(true);
        this.actions.setPaymentInstruments([]);
        if (this.paymentInstrument.BillingAddress && this.addressSwitcherAddress && this.addressSwitcherAddress.Id === this.paymentInstrument.BillingAddress.Id) {
          //leveraging the address switcher change callback to ensure shipping methods are updated
          this.onAddressSwitcherChangeCallback(paymentInstrument.BillingAddress, false);
        }

        //Remove the latest item from the list
        var selectedPaymentInstrumentIds = this.state.selectedPaymentInstrumentIds.asMutable();
        if (selectedPaymentInstrumentIds.length) {
          selectedPaymentInstrumentIds.splice(-1, 1);
        }
        //Add the changed method as the latest item
        selectedPaymentInstrumentIds.push(paymentInstrument.Id);
        this.actions.setPaymentInstrumentIds(selectedPaymentInstrumentIds);
      } else {
        if (paymentInstrument) {
          this.actions.setPaymentInstrumentIds([]);
          this.actions.addUnsavedPaymentMethod({
            PaymentInstrument: paymentInstrument
          });
          this.actions.setPaymentInstruments([paymentInstrument]);
        }
      }
      this.shippingAddressChanged();
      this.handleSameAsBillingCheckboxOnPaymentMethodChange(paymentInstrument);
      this.onChange()();
    }
  }, {
    key: "addPaymentInstrument",
    value: function addPaymentInstrument(paymentInstrument) {
      var selectedPaymentInstrumentIds = this.state.selectedPaymentInstrumentIds.asMutable();
      if (paymentInstrument && paymentInstrument.Id) {
        selectedPaymentInstrumentIds.push(paymentInstrument.Id);
      }
      this.actions.setPaymentInstrumentIds(selectedPaymentInstrumentIds);
      this.handleSameAsBillingCheckboxOnPaymentMethodChange(paymentInstrument);
      this.onChange()();
    }
  }, {
    key: "onAddressSwitcherChangeCallback",
    value: function onAddressSwitcherChangeCallback(address) {
      var triggerChangeCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.addressSwitcherAddress = address;
      this.temporaryShipToName = null;
      this.shippingAddressChanged();
      triggerChangeCallback && this.onChange()();
    }
  }, {
    key: "onAddressSwitcherCreateOrEditCallback",
    value: function onAddressSwitcherCreateOrEditCallback(address) {
      var _this8 = this;
      this.onAddressSwitcherChangeCallback(address);
      this.actions.retrieveCustomerAddresses(this.state.currentCustomerId).catch(function (error) {
        _this8.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "isLoadingData",
    value: function isLoadingData() {
      return this.state.isDbssShoppingCart ? false : !this.initializedWallet || !this.initializedHouseholdData || this.state.isFetchingWalletData;
    }
  }, {
    key: "canCreatePaymentInstruments",
    value: function canCreatePaymentInstruments() {
      return this.state.currentMemberCanCreatePaymentInstrument;
    }
  }, {
    key: "shouldHideSameAsBillingCheckbox",
    value: function shouldHideSameAsBillingCheckbox() {
      var currentPaymentInstrumentHasBillingAddressId = pathOr(false, ['BillingAddress', 'Id'], this.paymentInstrument);
      return this.state.shippingRequired && this.state.selectedPaymentInstrumentIds.length !== 1 || !currentPaymentInstrumentHasBillingAddressId;
    }
  }, {
    key: "getAddressSwitcherAddressId",
    value: function getAddressSwitcherAddressId() {
      return pathOr(null, ['Id'], this.addressSwitcherAddress);
    }
  }, {
    key: "getPaymentInstrumentAddressId",
    value: function getPaymentInstrumentAddressId() {
      return pathOr(null, ['BillingAddress', 'Id'], this.paymentInstrument);
    }
  }, {
    key: "handleSameAsBillingCheckboxOnPaymentMethodChange",
    value: function handleSameAsBillingCheckboxOnPaymentMethodChange(updatedPaymentInstrument) {
      if (this.shouldHideSameAsBillingCheckbox()) {
        this.isShippingAddressSameAsBilling = false;
        this.actions.setIsShippingAddressSameAsBilling(this.isShippingAddressSameAsBilling);
        this.actions.setProductOrderShippingAddressId(this.getAddressSwitcherAddressId());
        this.actions.setSelectedShippingMethodId(null);
      }
      if (this.isShippingAddressSameAsBilling) {
        var currentPaymentInstrumentBillingAddressId = pathOr(null, ['BillingAddress', 'Id'], updatedPaymentInstrument);
        if (currentPaymentInstrumentBillingAddressId) {
          if (currentPaymentInstrumentBillingAddressId !== this.state.selectedShippingAddressId) {
            this.actions.setProductOrderShippingAddressId(currentPaymentInstrumentBillingAddressId);
            this.actions.setSelectedShippingMethodId(null);
          }
        } else {
          this.isShippingAddressSameAsBilling = false;
          this.actions.setIsShippingAddressSameAsBilling(this.isShippingAddressSameAsBilling);
          this.actions.setProductOrderShippingAddressId(this.getAddressSwitcherAddressId());
          this.actions.setSelectedShippingMethodId(null);
        }
      }
    }
  }, {
    key: "shippingAddressChanged",
    value: function shippingAddressChanged() {
      var newShippingAddressId = this.isShippingAddressSameAsBilling ? this.getPaymentInstrumentAddressId() : this.getAddressSwitcherAddressId();
      this.handleTemporaryShipToNameUpdate();
      this.actions.setIsShippingAddressSameAsBilling(this.isShippingAddressSameAsBilling);
      this.actions.setProductOrderShippingAddressId(newShippingAddressId);
      this.actions.setSelectedShippingMethodId(null);
    }
  }, {
    key: "onShippingAddressSameAsBillingChanged",
    value: function onShippingAddressSameAsBillingChanged() {
      this.shippingAddressChanged();
      this.onChange()();
    }
  }, {
    key: "handleTemporaryShipToNameUpdate",
    value: function handleTemporaryShipToNameUpdate() {
      var paymentInstrumentShipToName = pathOr(this.temporaryShipToName, ['BillingAddress', 'ShipToName'], this.paymentInstrument);
      var addressSwitcherAddressShipToName = pathOr(this.temporaryShipToName, ['addressSwitcherAddress', 'ShipToName'], this);
      this.temporaryShipToName = this.isShippingAddressSameAsBilling ? paymentInstrumentShipToName : addressSwitcherAddressShipToName;
      this.onChangeTemporaryShipToName();
    }
  }, {
    key: "selectedPaymentIdsToInstruments",
    value: function selectedPaymentIdsToInstruments(paymentInstrumentIds, paymentInstruments) {
      var _this9 = this;
      return paymentInstrumentIds.map(function (paymentInstrumentId) {
        return _this9.selectedPaymentIdToInstrument(paymentInstrumentId, paymentInstruments);
      });
    }
  }, {
    key: "selectedPaymentIdToInstrument",
    value: function selectedPaymentIdToInstrument(paymentInstrumentId, paymentInstruments) {
      return paymentInstruments.find(propEq(paymentInstrumentId, 'Id'));
    }
  }, {
    key: "setIsGiftOrder",
    value: function setIsGiftOrder() {
      this.defaultInvalidNotificationDate();
      this.actions.setIsGiftOrder(this.isGiftOrder);
    }
  }, {
    key: "setGiftOrderInfo",
    value: function setGiftOrderInfo() {
      this.actions.setGiftOrderInfo(this.giftOrderInfo);
    }
  }, {
    key: "defaultInvalidNotificationDate",
    value: function defaultInvalidNotificationDate() {
      // Check for Invalid Date
      // This corrects a edge case where unchecking 'Send as Gift' when the three-field-date-input
      // places a value of Invalid Date into the state, causing re-selecting it to have
      // and empty value in the notificationDate. The same behavior will occur when navigating
      // back to products with and invalid date. This will also prevent the store from updating
      // the giftOrderInfo object just for enabling sendAsGift
      if (isNaN(pathOr(new Date(), ['notificationDate'], this.giftOrderInfo).valueOf())) {
        this.giftOrderInfo.notificationDate = this.currentDateTime;
        this.actions.setGiftOrderInfo(this.giftOrderInfo);
      }
    }
  }, {
    key: "hasNextCycle",
    value: function hasNextCycle() {
      var _this$state$currentSu, _this$state$currentSu2, _this$state$currentSu3;
      return ((_this$state$currentSu = this.state.currentSubscription) === null || _this$state$currentSu === void 0 ? void 0 : (_this$state$currentSu2 = _this$state$currentSu.Items) === null || _this$state$currentSu2 === void 0 ? void 0 : _this$state$currentSu2.some(function (currentItem) {
        return currentItem.ChangePricingPlan !== undefined;
      })) || !!((_this$state$currentSu3 = this.state.currentSubscription) !== null && _this$state$currentSu3 !== void 0 && _this$state$currentSu3.PendingOrderNumber);
    }
  }, {
    key: "shouldShowApplyChanges",
    value: function shouldShowApplyChanges() {
      var _this10 = this;
      var currentPlanId = null;
      var originalPlanId = null;
      if (this.state.modifiedSubscriptionItem && this.state.modifiedSubscriptionItem.PricingPlan) {
        currentPlanId = this.state.modifiedSubscriptionItem.PricingPlan.Id;
      }
      if (pathOr(0, ['Items', 'length'], this.state.currentSubscription)) {
        originalPlanId = pathOr(null, ['PricingPlan', 'Id'], this.state.currentSubscription.Items.find(function (currentItem) {
          return currentItem.Id === _this10.state.modifiedSubscriptionItem.Id;
        }));
      }
      if (this.state.isModifyingMode) {
        return currentPlanId !== originalPlanId && !this.state.isReplacingMode || this.hasNextCycle();
      } else if (this.state.isReplacingMode) {
        var _this$state$shoppingC, _this$state$shoppingC2, _this$state$shoppingC3;
        return (_this$state$shoppingC = this.state.shoppingCart) === null || _this$state$shoppingC === void 0 ? void 0 : (_this$state$shoppingC2 = _this$state$shoppingC.Items) === null || _this$state$shoppingC2 === void 0 ? void 0 : (_this$state$shoppingC3 = _this$state$shoppingC2.filter(function (item) {
          var _item$Details, _item$Details$Product;
          return (item === null || item === void 0 ? void 0 : (_item$Details = item.Details) === null || _item$Details === void 0 ? void 0 : (_item$Details$Product = _item$Details.Product) === null || _item$Details$Product === void 0 ? void 0 : _item$Details$Product.StructureType) === STRUCTURE_TYPES.BUNDLE;
        })) === null || _this$state$shoppingC3 === void 0 ? void 0 : _this$state$shoppingC3.length;
      }
    }
  }, {
    key: "isPaymentInstrumentRemoved",
    value: function isPaymentInstrumentRemoved() {
      return this.paymentInstrument && this.paymentInstrument.Status === GENERAL_STATUSES.REMOVED;
    }

    // Discretionary Discounts
  }, {
    key: "discretionaryDiscountCurrency",
    get: function get() {
      return pathOr(null, ['shoppingCart', 'Currency'], this.state) || this.state.currency || this.state.currentCustomerCurrencyCode || this.state.currentBusinessUnitCurrencyCode || null;
    }
  }, {
    key: "onEditDiscountClick",
    value: function onEditDiscountClick() {
      // must re-create the discount dialog data format where
      // selectedDiscounts is a map of Id to bool
      var discountForm = {
        selectedDiscounts: {},
        discountReason: this.state.discretionaryDiscountsReason
      };
      (this.state.discretionaryDiscountsId || []).forEach(function (discountId) {
        discountForm.selectedDiscounts[discountId] = true;
      });
      this.actions.setDiscountForm(discountForm);
      this.openDiscountDialog();
    }
  }, {
    key: "onRemoveDiscountClick",
    value: function onRemoveDiscountClick(discount) {
      // must re-create the discount dialog data format where
      // selectedDiscounts is a map of Id to bool
      var discountData = {
        selectedDiscounts: {},
        discountReason: null
      };
      if (discount) {
        (this.state.discretionaryDiscountsId || []).forEach(function (discountId) {
          discountData.selectedDiscounts[discountId] = true;
        });
        discountData.selectedDiscounts[discount.Id] = false;
        discountData.discountReason = this.state.discretionaryDiscountsReason;
      }
      this.setProductOrderDiscretionaryDiscounts(discountData);
      this.onChange()();
    }
  }, {
    key: "setProductOrderDiscretionaryDiscounts",
    value: function setProductOrderDiscretionaryDiscounts(discountData) {
      this.actions.setProductOrderDiscretionaryDiscounts({
        selectedIds: Object.keys(discountData.selectedDiscounts).filter(function (discountMapId) {
          return discountData.selectedDiscounts[discountMapId];
        }),
        reason: discountData.discountReason
      });
    }
  }, {
    key: "applyDiscount",
    value: function applyDiscount(discountData) {
      this.closeDiscountDialog();
      this.setProductOrderDiscretionaryDiscounts(discountData);
      this.onChange()();
    }
  }, {
    key: "closeDiscountDialog",
    value: function closeDiscountDialog() {
      this.showDiscountForm = false;
      this.applyDiscountDialogApi.close();
    }
  }, {
    key: "openDiscountDialog",
    value: function openDiscountDialog() {
      var _this11 = this;
      this.showDiscountForm = true;
      this.$timeout(function () {
        _this11.applyDiscountDialogApi.open();
      });
    }

    // Shipping Methods
  }, {
    key: "shippingMethodSelected",
    value: function shippingMethodSelected(shippingMethodId) {
      this.actions.setSelectedShippingMethodId(shippingMethodId);
      this.onChange()();
    }

    // Subscription Fees
  }, {
    key: "onWaiveFeeSelected",
    value: function onWaiveFeeSelected(waiveFee) {
      this.actions.setRestoreOrderWaiveFee(waiveFee);
      if (waiveFee) {
        this.actions.setRestoreOrderWaiveLateFee(false);
        this.actions.setRestoreOrderWaiveLateFeeReason(null);
        this.actions.clearCartSummaryForWaiveCharge();
      } else {
        this.actions.setRestoreOrderWaiveFeeReason(null);
        this.onChange()();
      }
    }
  }, {
    key: "onWaiveFeeReasonSelected",
    value: function onWaiveFeeReasonSelected(waiveFeeReason) {
      this.actions.setRestoreOrderWaiveFeeReason(waiveFeeReason);
    }
  }, {
    key: "onWaiveLateFeeSelected",
    value: function onWaiveLateFeeSelected(waiveLateFee) {
      this.actions.setRestoreOrderWaiveLateFee(waiveLateFee);
      if (!waiveLateFee) {
        this.actions.setRestoreOrderWaiveLateFeeReason(null);
        this.onChange()();
      }
    }
  }, {
    key: "onWaiveLateFeeReasonSelected",
    value: function onWaiveLateFeeReasonSelected(waiveLateFeeReason) {
      this.actions.setRestoreOrderWaiveLateFeeReason(waiveLateFeeReason);
      this.onChange()();
    }
  }, {
    key: "setDefaultBillCycle",
    value: function setDefaultBillCycle() {
      this.selectedBillCycle = this.state.candidateBillCycles[0];
    }
  }, {
    key: "doErrorsExistOnFdoForm",
    value: function doErrorsExistOnFdoForm(isFormValid) {
      this.errorsExistOnForm = isFormValid;
    }
  }, {
    key: "onExecutionOptionChange",
    value: function onExecutionOptionChange(executionOptionsModel) {
      this.actions.setOttExecutionOptions(executionOptionsModel);
    }
  }, {
    key: "onFdoFormValidityChange",
    value: function onFdoFormValidityChange(message) {
      this.fdoErrorMessageFromComponent = message;
      return message;
    }
  }, {
    key: "getTomorrow",
    value: function getTomorrow() {
      var today = moment();
      return moment(today).add(1, 'days');
    }
  }, {
    key: "shouldShowFdoExecutionOptionsError",
    value: function shouldShowFdoExecutionOptionsError() {
      return this.errorsExistOnForm && this.formController.$submitted;
    }
  }, {
    key: "onListUpdated",
    value: function onListUpdated() {
      this.onAdditionalPropertyListUpdated()();
    }
  }, {
    key: "onPropertyChanged",
    value: function onPropertyChanged(id, newValue) {
      this.onAdditionalPropertyChanged()(id, newValue);
    }
  }, {
    key: "setOrderDetails",
    value: function setOrderDetails() {
      this.actions.setOrderDetails(this.orderDetails);
    }
  }, {
    key: "getFilteredReasonCodes",
    value: function getFilteredReasonCodes() {
      return (Object.values(this.state.reasonCodes) || []).filter(function (code) {
        var _code$AdditionalPrope;
        return (code === null || code === void 0 ? void 0 : (_code$AdditionalPrope = code.AdditionalProperties) === null || _code$AdditionalPrope === void 0 ? void 0 : _code$AdditionalPrope.order_type_code) === +ORDER_TYPE_CODE.NEW;
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      if (this.uiNotificationService.numActiveToasts()) {
        this.uiNotificationService.clear();
      }
      this.defaultInvalidNotificationDate();
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./products.checkout.html'),
  controller: CheckoutController,
  require: {
    formController: '^^form'
  },
  bindings: {
    additionalPropertiesCollection: '<',
    additionalPropertyValueOptions: '<',
    isCalculatingQuote: '<',
    isNewOrder: '<',
    onAdditionalPropertyListUpdated: '&',
    onAdditionalPropertyChanged: '&',
    onChange: '&',
    shippingMethodId: '<'
  }
};